/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

import { BUSINESS_STATUSES, PAYMENT_SOURCES } from '@/lib/consts.js'
import { isEmpty } from 'ramda'

import type { RedirectContext } from '../types'

export const booksyBillingRedirect = ({ store, router, logger }: RedirectContext): unknown => {
  if (
    store.getters['business/paymentSource'] === PAYMENT_SOURCES.BOOKSY_BILLING
    && [
      BUSINESS_STATUSES.ACTIVE_OVERDUE,
      BUSINESS_STATUSES.BLOCKED_OVERDUE,
    ].includes(store.getters['business/businessStatus'])
    && isEmpty(store.getters['subscription/subscriptionBilling'])
    && store.getters['identity/isManagerOrHigher']
  ) {
    logger.debug(`empty booksy billing found! >>> your-subscription`)
    return router.push({
      name: 'settings.subscription.your-subscription',
      params: {
        businessId: store.getters['business/businessId'],
      },
    })
  }
}
